// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"X_-z"};